import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">Skighnet · Amplify Gen 2</p>
        <h1>Welcome to My Cannabis License</h1>
        <p className="lede">
          Your go-to source for the latest updates and insights on cannabis policy and culture in our community.
        </p>
        <div className="cta-row">
          <a href="/updates" target="_blank">
            Latest Updates
          </a>
          <a href="/education" target="_blank" className="secondary">
            Educational Resources
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Local Cannabis Law Updates</h2>
          <p>
            Stay informed with the latest changes in cannabis legislation and regulations affecting our area.
          </p>
        </article>
        <article>
          <h2>Understanding Legal Status</h2>
          <p>
            Get clear and concise information about the legal status of cannabis in our region, including what it means for residents.
          </p>
        </article>
        <article>
          <h2>Educational Content</h2>
          <p>
            Explore a variety of articles and guides designed to educate the community about cannabis culture and its implications.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;